import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { get, post, del } from "@/lib/api";
import { PageLoader, PageHeader, EmptyState, Badge } from "@/components/common";
import { Newspaper, Plus, X, Trash2 } from "lucide-react";

export default function AdminCurrentAffairs() {
  const qc = useQueryClient();
  const [show, setShow] = useState(false);
  const { data, isLoading } = useQuery({ queryKey: ["admin-ca"], queryFn: () => get("/current-affairs") });
  const remove = async (id) => { await del(`/current-affairs/${id}`); toast.success("Deleted"); qc.invalidateQueries({ queryKey: ["admin-ca"] }); };
  return (
    <div>
      <PageHeader title="Current Affairs & GK" subtitle="Publish daily updates for students" action={<button onClick={() => setShow(true)} data-testid="new-ca-btn" className="bg-indigo-800 text-white font-semibold px-5 py-2.5 rounded-lg flex items-center gap-2"><Plus className="h-4 w-4" /> New Post</button>} />
      {show && <CAForm onClose={() => setShow(false)} onSaved={() => { setShow(false); qc.invalidateQueries({ queryKey: ["admin-ca"] }); }} />}
      {isLoading ? <PageLoader /> : !data?.length ? <EmptyState icon={Newspaper} title="No posts yet" /> : (
        <div className="grid sm:grid-cols-2 gap-4">{data.map((c) => (
          <div key={c.id} className="bg-white rounded-2xl border border-slate-200 p-5">
            <div className="flex items-center justify-between"><Badge tone="indigo">{c.category}</Badge><button onClick={() => remove(c.id)} className="text-red-500"><Trash2 className="h-4 w-4" /></button></div>
            <h3 className="font-display font-bold text-slate-900 mt-2">{c.title}</h3><p className="text-sm text-slate-600 mt-1">{c.body}</p>
          </div>))}</div>
      )}
    </div>
  );
}
function CAForm({ onClose, onSaved }) {
  const [c, setC] = useState({ title: "", body: "", category: "General", language: "English" });
  const save = async () => { if (!c.title.trim()) return toast.error("Title required"); await post("/current-affairs", c); toast.success("Published"); onSaved(); };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-6 max-w-lg w-full">
        <div className="flex items-center justify-between mb-4"><h3 className="font-display font-bold text-xl">New Post</h3><button onClick={onClose}><X className="h-5 w-5" /></button></div>
        <div className="space-y-3">
          <input value={c.title} onChange={(e) => setC({ ...c, title: e.target.value })} data-testid="ca-title" className="inp" placeholder="Title" />
          <input value={c.category} onChange={(e) => setC({ ...c, category: e.target.value })} className="inp" placeholder="Category" />
          <textarea value={c.body} onChange={(e) => setC({ ...c, body: e.target.value })} rows={4} data-testid="ca-body" className="inp" placeholder="Content" />
        </div>
        <div className="flex gap-2 mt-5"><button onClick={onClose} className="px-4 py-2.5 rounded-lg border border-slate-200 font-semibold text-slate-600">Cancel</button><button onClick={save} data-testid="save-ca-btn" className="ml-auto px-5 py-2.5 rounded-lg bg-indigo-800 text-white font-bold">Publish</button></div>
      </div>
      <style>{`.inp{width:100%;border:1px solid #E2E8F0;border-radius:.5rem;padding:.55rem .7rem;font-size:.875rem;outline:none;}`}</style>
    </div>
  );
}
